// eslint-disable-next-line
export default [
    {
        id: 1,
        isChecked: false,
        size: 25
    },
    {
        id: 2,
        isChecked: false,
        size: 30
    },
    {
        id: 3,
        isChecked: false,
        size: 35
    },
    {
        id: 4,
        isChecked: false,
        size: 50
    },
    {
        id: 5,
        isChecked: false,
        size: 100
    },
]